import useAppTranslation from "@hooks/language/useAppTranslation";
import { Badge } from "@mantine/core";
import type COrderStatus from "@modules/order/models/COrderStatus";

interface Props {
  status: COrderStatus;
}

const OrderStatus: React.FC<Props> = ({ status }) => {
  const { t } = useAppTranslation("pages.order");
  if (!status) {
    return;
  }

  return (
    <Badge
      className="h-6 gap-1"
      color={status.color}
      leftSection={status.icon}
      radius="md"
      style={{ borderColor: status.color }}
      variant="light"
    >
      {status.nameKey ? t(status.nameKey) : status.name}
    </Badge>
  );
};

export default OrderStatus;
